<script lang="jsx">
import ErrorBlock from "./ErrorBlock";

const NewFormActions = ({ context, reset, action, buttonName, html }) => {
    return [
      <div>{ context?.saveSuccess && <div class="success">{context?.saveSuccess}</div> }</div>,
      <div>{ context?.updateSuccess && <div class="success">{context?.updateSuccess}</div> }</div>,
      <div>{ context?.clientError && <ErrorBlock error={context?.clientError} /> }</div>,
      <div align="right">
        {html && html}
        { reset && <input type="reset" value="Reset" onClick={reset} /> }
        {
          (context?.saving || context?.updating)  
            ? <button class="success" disabled><div class="spinner" /></button>
            : <button class="success" onClick={action}>{buttonName || 'Save'}</button>
        }
      </div>
    ];
};
export default NewFormActions;
</script>
